import React, { useEffect } from 'react';

const REGISTER_URL = 'https://partner.activikid.hk/partner-register';

function PartnerRegisterPage() {
  useEffect(() => {
    window.location.replace(REGISTER_URL);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#fff',
    }}>
      <img
        src="/Images/loading-cat.png"
        alt="Loading"
        style={{ width: '280px', maxWidth: '60vw' }}
      />
      <p style={{ color: '#888', fontSize: '1.6rem', marginTop: '1.2rem', fontWeight: 500 }}>
        Redirecting...
      </p>
    </div>
  );
}

export default PartnerRegisterPage;
